import { render, staticRenderFns } from "./CheckboxInputComponent.vue?vue&type=template&id=e204aac2&lang=pug"
import script from "./CheckboxInputComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxInputComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckboxInputComponent.vue?vue&type=style&index=0&id=e204aac2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports